import React from 'react';

/**
 * 直播控制按钮
 * - 开始/停止直播
 * - 开关麦克风
 * - 开关摄像头
 */
function Controls({ isLive, isHost, audioEnabled, videoEnabled, onStart, onStop, onToggleAudio, onToggleVideo }) {
  if (!isHost) return null;

  return (
    <div className="flex items-center gap-3 p-3 bg-dark-800 rounded-lg">
      {!isLive ? (
        <button
          onClick={onStart}
          className="px-6 py-2 bg-red-600 hover:bg-red-700 rounded-full font-semibold transition flex items-center gap-2"
        >
          <span className="w-3 h-3 bg-white rounded-full"></span>
          开始直播
        </button>
      ) : (
        <button
          onClick={onStop}
          className="px-6 py-2 bg-gray-600 hover:bg-gray-700 rounded-full font-semibold transition"
        >
          ⏹ 结束直播
        </button>
      )}

      <button
        onClick={onToggleAudio}
        className={`px-4 py-2 rounded-full transition ${audioEnabled ? 'bg-dark-700 hover:bg-dark-600' : 'bg-red-800 hover:bg-red-700'}`}
        title={audioEnabled ? '静音' : '取消静音'}
      >
        {audioEnabled ? '🎤' : '🔇'}
      </button>

      <button
        onClick={onToggleVideo}
        className={`px-4 py-2 rounded-full transition ${videoEnabled ? 'bg-dark-700 hover:bg-dark-600' : 'bg-red-800 hover:bg-red-700'}`}
        title={videoEnabled ? '关闭摄像头' : '开启摄像头'}
      >
        {videoEnabled ? '📹' : '📷'}
      </button>
    </div>
  );
}

export default Controls;
